(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fdc-arff-options"] && !Shopify.designMode) return;
  try {
    
(function(){
const root=document.querySelector('.fdc-arff-options[data-product-id="{{ product.id }}"]'); if(!root)return;
const ladder=root.querySelector('[id^="fdc-arff-ladder-"]');
const airport=root.querySelector('[id^="fdc-arff-airport-"]');
function airportSelected(){return [...document.querySelectorAll('select[name^="options["],input[name^="options["]')].some(e=>(e.value||'').toLowerCase().includes('add airport initials'));}
document.addEventListener('submit',function(e){
const form=e.target;if(!form.matches('form[action="/cart/add"],form[action$="/cart/add"]'))return;
const ai=airportSelected();if(ai&&!airport.value.trim()){e.preventDefault();airport.focus();return;}
[['Ladder Type',ladder.value],['Airport Initials / Name',ai?airport.value.trim():'None']].forEach(([k,v])=>{let x=form.querySelector('input[data-fdc-property="'+k+'"]');if(!x){x=document.createElement('input');x.type='hidden';x.name='properties['+k+']';x.dataset.fdcProperty=k;form.appendChild(x);}x.value=v;});
},true);
if(!window.__fdcTdaCartPatched){window.__fdcTdaCartPatched=true;const of=window.fetch.bind(window);window.fetch=async(input,init={})=>{
const url=typeof input==='string'?input:input?.url||'',body=init?.body;
if(!/\/cart\/add(?:\.js)?(?:\?|$)/.test(url)||!(body instanceof FormData))return of(input,init);
const entries=[...body.entries()],tdas=entries.filter(([k,v])=>/^properties\[Ladder \d+ Type\]$/.test(k)&&String(v)==='TDA').length;
if(!tdas)return of(input,init);
const id=Number(body.get('id')),qty=Number(body.get('quantity'))||1,props={};
for(const [k,v] of entries){const mm=k.match(/^properties\[(.+)\]$/);if(mm)props[mm[1]]=String(v);}
const main={id,quantity:qty};if(Object.keys(props).length)main.properties=props;
const payload={items:[main,{id:44232150810698,quantity:tdas*qty,parent_id:id,properties:{'_fdc_addon_type':'TDA Ladder Upgrade'}}]};
const h=new Headers(init.headers||{});h.set('Content-Type','application/json');return of(input,{...init,headers:h,body:JSON.stringify(payload)});
};}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
